// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniAppContainer_container__3TO4b","main":"MiniAppContainer_main__3Sugp"};